// ContactSection.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import PhoneInputWithCountryCode from "../../../components/common/PhoneInputWithCountryCode";

const ContactSection = ({ form, errors, handleInputChange }) => {
  const { t, i18n } = useTranslation();

  return (
    <div
      dir={i18n.dir()}
      lang={i18n.language}
      style={{ width: "100%", maxWidth: "960px", margin: "0 auto" }}
    >
      <h3
        style={{
          fontSize: "18px",
          fontWeight: "600",
          color: "#1f2937",
          marginBottom: "24px",
        }}
      >
        {t("clinicSetup.contact.title")}
      </h3>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "24px",
        }}
      >
        <div>
          <label
            style={{
              display: "block",
              fontSize: "14px",
              fontWeight: "500",
              color: "#374151",
              marginBottom: "8px",
            }}
          >
            {t("clinicSetup.contact.fields.mobile.label")}{" "}
            <span style={{ color: "#ef4444" }}>*</span>
          </label>
          <PhoneInputWithCountryCode
            value={form.mobile || ""}
            onChange={(val) =>
              handleInputChange({ target: { name: "mobile", value: val } })
            }
            placeholder={t("clinicSetup.contact.fields.mobile.placeholder")}
            defaultCountryCode="+962"
          />
          {errors.mobile && (
            <div style={{ color: "#ef4444", fontSize: "13px", marginTop: "6px" }}>
              {errors.mobile}
            </div>
          )}
        </div>
        <div>
          <label
            style={{
              display: "block",
              fontSize: "14px",
              fontWeight: "500",
              color: "#374151",
              marginBottom: "8px",
            }}
          >
            {t("clinicSetup.contact.fields.telephone.label")}
          </label>
          <input
            type="text"
            name="telephone"
            value={form.telephone}
            onChange={handleInputChange}
            placeholder={t("clinicSetup.contact.fields.telephone.placeholder")}
            style={{
              width: "100%",
              padding: "12px 16px",
              fontSize: "15px",
              border: errors.telephone
                ? "2px solid #ef4444"
                : "2px solid #e5e7eb",
              borderRadius: "10px",
              outline: "none",
              transition: "all 0.2s ease",
              background: "#fff",
              boxSizing: "border-box",
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#3b82f6";
              e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = errors.telephone
                ? "#ef4444"
                : "#e5e7eb";
              e.target.style.boxShadow = "none";
            }}
          />
          {errors.telephone && (
            <div style={{ color: "#ef4444", fontSize: "13px", marginTop: "6px" }}>
              {errors.telephone}
            </div>
          )}
        </div>
        <div>
          <label
            style={{
              display: "block",
              fontSize: "14px",
              fontWeight: "500",
              color: "#374151",
              marginBottom: "8px",
            }}
          >
            {t("clinicSetup.contact.fields.email.label")}{" "}
            <span style={{ color: "#ef4444" }}>*</span>
          </label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleInputChange}
            placeholder={t("clinicSetup.contact.fields.email.placeholder")}
            style={{
              width: "100%",
              padding: "12px 16px",
              fontSize: "15px",
              border: errors.email ? "2px solid #ef4444" : "2px solid #e5e7eb",
              borderRadius: "10px",
              outline: "none",
              transition: "all 0.2s ease",
              background: "#fff",
              boxSizing: "border-box",
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#3b82f6";
              e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = errors.email ? "#ef4444" : "#e5e7eb";
              e.target.style.boxShadow = "none";
            }}
          />
          {errors.email && (
            <div style={{ color: "#ef4444", fontSize: "13px", marginTop: "6px" }}>
              {errors.email}
            </div>
          )}
        </div>
        <div>
          <label
            style={{
              display: "block",
              fontSize: "14px",
              fontWeight: "500",
              color: "#374151",
              marginBottom: "8px",
            }}
          >
            {t("clinicSetup.contact.fields.website.label")}
          </label>
          <input
            type="text"
            name="website"
            value={form.website}
            onChange={handleInputChange}
            placeholder={t("clinicSetup.contact.fields.website.placeholder")}
            style={{
              width: "100%",
              padding: "12px 16px",
              fontSize: "15px",
              border: errors.website ? "2px solid #ef4444" : "2px solid #e5e7eb",
              borderRadius: "10px",
              outline: "none",
              transition: "all 0.2s ease",
              background: "#fff",
              boxSizing: "border-box",
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#3b82f6";
              e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = errors.website
                ? "#ef4444"
                : "#e5e7eb";
              e.target.style.boxShadow = "none";
            }}
          />
          {errors.website && (
            <div style={{ color: "#ef4444", fontSize: "13px", marginTop: "6px" }}>
              {errors.website}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
